

// cspell:disable

import React, { useEffect, useRef, useState } from 'react';
import { Form, Modal } from 'react-bootstrap';
import blogFetch from '../../axios/config';
import toast from 'react-hot-toast';
import { ModalApontamentoEmbolsadoProps } from './Types';


const ModalApontamentoEmbolsado: React.FC<ModalApontamentoEmbolsadoProps> = ({ show, onHide }) => {

    const [peca, setPeca] = useState({
        ordem: "",
        tipoPeca: "",
        codigoVeiculo: "",
        projeto: "",
        veiculo: "",
        ultimoApont: "",
        prensadora: ""
    });


    const inputRef = useRef<HTMLInputElement>(null);
    const user = JSON.parse(localStorage.getItem('user') || '{}');


    const handleSubmit = async () => {
        try {
            if (!peca.ordem.trim()) {
                toast.error("Por favor, insira a ordem da peça.");
                return;
            }

            if (!peca.prensadora.trim()) {
                toast.error("Por favor, selecione o prensador.");
                return;
            }

            const payload = {
                Ordem: peca.ordem,
                Matricula: user.user_SAPMatricula,
                prensadora: peca.prensadora
            };

            await blogFetch.post(`ISAGA_ApontamentoEmbolsado/apontamento_sap`, payload);

            toast.success(`Apontamento SAP realizado para a ordem: ${peca.ordem}`);
            resetForm();
        } catch (error: any) {
            console.error("Erro ao realizar apontamento:", error);
            toast.error(error.response?.data?.message || "Erro ao realizar apontamento SAP.");
        }
    };

    const resetForm = () => {
        setPeca({
            ordem: "",
            tipoPeca: "",
            codigoVeiculo: "",
            projeto: "",
            veiculo: "",
            ultimoApont: "",
            prensadora: ""
        });
    };


    const handleCancel = () => {
        resetForm();
        onHide();
    };

    useEffect(() => {
        if (!show || !peca.ordem?.trim()) return;
        const timeout = setTimeout(() => buscarPeca(peca.ordem), 800);
        return () => clearTimeout(timeout);
    }, [peca.ordem, show]);


    const buscarPeca = async (ordem: string) => {
        try {

            const { data } = await blogFetch.get(`ISAGA_ApontamentoEmbolsado/getPeca/${ordem}`);



            if (!data) {
                toast.error("Peça não encontrada.");
                return;
            }
            setPeca((prev) => ({
                ...prev,
                codigoVeiculo: data.ordem_VehCod || "",
                projeto: data.subProduto_Desc || "",
                tipoPeca: data.ordem_Part_Short || "",
                veiculo: data.ordem_VehDesc || "",
                ultimoApont: data.ordem_UltSetApontado || "",
            }));
        } catch (error: any) {
            console.error("Erro ao buscar peça:", error);
            toast.error(error.response?.data || "Erro ao buscar peça.");
            resetForm();
        }
    };


    return (
        <Modal show={show} onHide={handleCancel} centered backdrop="static">
            <Modal.Header closeButton>
                <Modal.Title>Apontamento Embolsado SAP</Modal.Title>
            </Modal.Header>
            <Modal.Body>

                <div className="card p-3 shadow-sm rounded-3 mb-3">
                    <Form onSubmit={(e: any) => e.preventDefault()}>
                        <Form.Group className="mb-3">
                            <Form.Label>Ordem</Form.Label>
                            <Form.Control
                                type="text"
                                value={peca.ordem}
                                ref={inputRef}
                                onChange={(e) => setPeca((p) => ({ ...p, ordem: e.target.value }))}
                                placeholder="Digite a ordem da peça"
                            />
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label>Seladora</Form.Label>
                            <Form.Control
                                as="select"
                                value={peca.prensadora}
                                onChange={(e) => setPeca((p) => ({ ...p, prensadora: e.target.value }))}
                                placeholder="Escolha o prensador"
                            >
                                <option value="">Selecione a Seladora</option>
                                <option value="PR01">SL-01</option>
                                <option value="PR02">SL-02</option>
                                <option value="PR03">SL-03</option>
                                <option value="PR04">Sl-04</option>
                            </Form.Control>
                        </Form.Group>
                    </Form>

                    <div className="card p-3 shadow-sm rounded-3">
                        <h6 className="fw-bold text-secondary mb-3">Informações do Veículo</h6>
                        <div className="row g-3">
                            <div className="col-md-6">
                                <label className="form-label small fw-semibold text-muted">Tipo Peça</label>
                                <input value={peca.tipoPeca} className="form-control" readOnly />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label small fw-semibold text-muted">Código Veículo</label>
                                <input value={peca.codigoVeiculo} className="form-control" readOnly />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label small fw-semibold text-muted">Ultimo Apontamento</label>
                                <input value={peca.ultimoApont} className="form-control" readOnly />
                            </div>
                            <div className="col-md-6">
                                <label className="form-label small fw-semibold text-muted">Projeto</label>
                                <input value={peca.projeto} className="form-control" readOnly />
                            </div>
                            <div className="col-12">
                                <label className="form-label small fw-semibold text-muted">Veículo</label>
                                <input value={peca.veiculo} className="form-control" readOnly />
                            </div>


                        </div>
                    </div>

                </div>

            </Modal.Body>
            <Modal.Footer className="d-flex justify-evenly">
                <button className="btn btn-secondary justify-end" onClick={handleCancel}>Cancelar</button>
                <button className="btn btn-primary justify-start" onClick={() => { handleSubmit() }}>Apontar sap</button>
            </Modal.Footer>

        </Modal >
    );
};

export default ModalApontamentoEmbolsado;